<iframe [src]="notifyListUrl" width="100%" style="height: calc(100vh - 10.3em);" frameborder="0" webkitallowfullscreen mozallowfullscreen
      allowfullscreen></iframe>
